export default __webpack_public_path__ + "static/media/SAV_interior_2.d83c6c12.png";